import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  addLocation({ commit }, item) {
    return this.$axios.$post('admin/locations/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeLocation({ commit }, item) {
    return this.$axios.$delete(`admin/locations/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateLocation({ commit }, item) {
    return this.$axios.$put(`admin/locations/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchLocations({ commit }) {
    return this.$axios.$get('admin/locations').then((response) => {
      commit('load', response.data)
    })
  },
}
